import config from '@/config'

let loaderPromise = null

export default function MapLoader() {
  if (window.AMap) {
    return Promise.resolve(window.AMap)
  }

  if (loaderPromise) {
    return loaderPromise
  }

  const env = process.env.VUE_APP_type
  const mapKey = config.mapKey && config.mapKey[env]
  const serviceHost = config.mapSecretKey && config.mapSecretKey[env]

  loaderPromise = new Promise((resolve, reject) => {
    if (!mapKey) {
      reject(new Error(`未配置 ${env} 环境的高德地图 Key`))
      return
    }

    if (serviceHost) {
      window._AMapSecurityConfig = {
        ...(window._AMapSecurityConfig || {}),
        serviceHost
      }
    }

    window.initAMap = () => {
      resolve(window.AMap)
      delete window.initAMap
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.dataset.amapLoader = 'true'
    script.src = `https://webapi.amap.com/maps?v=2.0&key=${encodeURIComponent(mapKey)}&callback=initAMap&plugin=AMap.Geocoder,AMap.ToolBar`
    script.onerror = () => {
      loaderPromise = null
      delete window.initAMap
      script.remove()
      reject(new Error('高德地图 SDK 加载失败'))
    }
    document.head.appendChild(script)
  })

  return loaderPromise
}
